import { render, staticRenderFns } from "./SyncToCooperation.vue?vue&type=template&id=bcfd1f2c&scoped=true&"
import script from "./SyncToCooperation.vue?vue&type=script&lang=js&"
export * from "./SyncToCooperation.vue?vue&type=script&lang=js&"
import style0 from "./SyncToCooperation.vue?vue&type=style&index=0&id=bcfd1f2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfd1f2c",
  null
  
)

export default component.exports